import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50px",
        backgroundColor: "white",
      }}
    >
      <footer>
        <a
          href="https://cookienotice.deloitte.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Cookies
        </a>
      </footer>
    </div>
  );
};

export default Footer;
